import { AmmendImmActivityFilter, FilterParams, IExitKPIReportFilter } from './api.gen';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api.gen';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import { Logger } from '../utils/Logger';



@Injectable()
export class CSVReportService {
    baseUrl: string;
    constructor(private http: HttpClient, private common: CommonService, @Inject(API_BASE_URL) baseUrl?: string) {
        this.baseUrl = baseUrl;
    }



    downloadreport(isRecruitment: boolean, FilterParameters: FilterParams): Observable<Blob> {
        let reporturl = this.baseUrl + `/api/Candidate/ExportReport?isRecruitment=${isRecruitment}`;
        return this.http.post<Blob>(reporturl, FilterParameters, { responseType: 'Blob' as 'json' });
    }

    // downloadImmreport(visaType: string, FilterParameters: FilterParams): Observable<Blob> {
    //     let reporturl = this.baseUrl + `/api/Immigration/ExportImmigrationReport?visaType=${visaType}`;
    //     return this.http.post<Blob>(reporturl, FilterParameters, { responseType: 'Blob' as 'json' });
    // }
    downloadImmreport(visaType: string, FilterParameters: FilterParams): Observable<boolean> {
        let reporturl = this.baseUrl + `/api/Immigration/ExportImmigrationReport?visaType=${visaType}`;
        return this.http.post<boolean>(reporturl, FilterParameters);//, { responseType: "blob" });
    }

    downloadExitreport(exitType: string, FilterParameters: FilterParams): Observable<Blob> {
        let reporturl = this.baseUrl + `/api/Exit/ExportExitReportToCSV?exitType=${exitType}`;
        return this.http.post<Blob>(reporturl, FilterParameters, { responseType: 'Blob' as 'json' });
  }
  downloadExitReportBasedOnLocation(filter: IExitKPIReportFilter) {
        let reporturl = this.baseUrl + `/api/Exit/ExportExitReportBasedOnLocation`;
        return this.http.post<Blob>(reporturl, filter, { responseType: 'Blob' as 'json' });
    }
    downloadProcessorReport(processorId: number, FilterParameters: FilterParams): Observable<Blob> {
        let reporturl = this.baseUrl + `/api/Immigration/ExportProcessorRequests?processorId=${processorId}`;
        return this.http.post<Blob>(reporturl, FilterParameters, { responseType: 'Blob' as 'json' });
    }
    downloadPJCReport(pjcId: number, FilterParameters: FilterParams): Observable<Blob> {
        let reporturl = this.baseUrl + `/api/Immigration/ExportPJCRequests?pjcId=${pjcId}`;
        return this.http.post<Blob>(reporturl, FilterParameters, { responseType: 'Blob' as 'json' });
    }
    downloadimmigrationActivityReport(immigrationProfileId: number, FilterParameters: FilterParams): Observable<Blob> {
        let reporturl = this.baseUrl + `/api/Immigration/ExportImmigrationActivity?immigrationProfileId=${immigrationProfileId}`;
        return this.http.post<Blob>(reporturl, FilterParameters, { responseType: 'Blob' as 'json' });
    }
    downloadEmployeeReport(FilterParameters: FilterParams): Observable<Blob> {
        let reporturl = this.baseUrl + `/api/EmployeeProfile/ExportReport`;
        return this.http.post<Blob>(reporturl, FilterParameters, { responseType: 'Blob' as 'json' });
    }
    downloadimmigrationActivityConfigReport(filter: AmmendImmActivityFilter, FilterParameters: FilterParams, isActive: boolean): Observable<Blob> {
        return this.http.post<Blob>(`${this.baseUrl}/api/Configuration/ExportImmigrationActivities?isActive=${isActive}`, filter, { responseType: 'Blob' as 'json' });
    }
    downloadcwreport(FilterParameters: FilterParams): Observable<Blob> {
        let reporturl = this.baseUrl + `/api/CW/ExportCWReportToCSV`;
        return this.http.post<Blob>(reporturl, FilterParameters, { responseType: 'Blob' as 'json' });
  }

   downloadTimelineReport(officelocationCountryId: number,FilterParameters: FilterParams): Observable<Blob> {
        let reporturl = this.baseUrl + `/api/Candidate/ExportTimelineReport?officelocationCountryId=${officelocationCountryId}`;
        return this.http.post<Blob>(reporturl,FilterParameters, { responseType: 'Blob' as 'json' });
    }

    downloadPendingActionReport(FilterParameters: FilterParams): Observable<Blob> {
        let reporturl = this.baseUrl + `/api/Candidate/ExportPendingActionReport`;
        return this.http.post<Blob>(reporturl,FilterParameters, { responseType: 'Blob' as 'json' });
    }



}
